// src/components/dashboard/StatusChip.tsx

import React from "react";
import { STATUS_CONFIG } from "../../constants/theme.constants";

interface StatusChipProps {
  status: string;
}

export const StatusChip: React.FC<StatusChipProps> = ({ status }) => {
  const config = STATUS_CONFIG[status as keyof typeof STATUS_CONFIG] || {
    dotColor: "#888780",
    badgeBg: "#F1EFE8",
    badgeText: "#5F5E5A",
    badgeBorder: "#D3D1C7",
    icon: () => null,
    label: status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
  };

  return (
    <div
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold transition-all duration-200 hover:scale-105"
      style={{
        background: config.badgeBg,
        color: config.badgeText,
        border: `1px solid ${config.badgeBorder}`,
      }}
    >
      <span
        className="rounded-full flex-shrink-0"
        style={{
          width: 6,
          height: 6,
          background: config.dotColor,
        }}
      />
      <span>{config.label}</span>
    </div>
  );
};